import type { GameHistoryNoteResponse } from "libs/apiClient";

/** React Query key segment for `getDiscoverGameHistoryNotes` (apiClient operation name). */
export const DISCOVER_GAME_HISTORY_NOTES_QUERY_KEY = "getDiscoverGameHistoryNotes";

/** Feed item `type` from `GameHistoryNoteResponse` (apiClient / backend). */
export const GameHistoryNoteItemType = {
	Internal: "internal",
	Log: "log",
} as const satisfies Record<string, GameHistoryNoteResponse["type"]>;

export type GameHistoryPendingFile = {
	id: string;
	file: File;
	base64: string;
};

export function createGameHistoryPendingFile(file: File, base64: string): GameHistoryPendingFile {
	return { id: crypto.randomUUID(), file, base64 };
}

// Keep in sync with GameHistoryNoteAllowedFileTypes::BY_MIME (PHP)
export const GAME_HISTORY_ACCEPTED_FILE_TYPES: Record<string, string[]> = {
	"image/png": [".png"],
	"image/jpeg": [".jpg", ".jpeg"],
	"image/heic": [".heic"],
	"application/pdf": [".pdf"],
	"application/vnd.ms-excel": [".xls"],
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
};
